<!-- BARRA SUPERIOR -->
<nav *ngIf="getActualPage() != '/login'" class="navbar">

  <!-- <button type="button" class="navbar-toggle" id="close-arrow" (click)="toggleSidebar()" data-toggle="collapse"
    [disabled]="sidebarIsOpen ? true : false">
    <span class="sr-only">Toggle navigation</span>
    <span class="icon-bar"></span>
    <span class="icon-bar"></span>
    <span class="icon-bar"></span>
  </button> -->
  <!-- <p class="text-cap" *ngIf="sidebarIsOpen">RMCAP 2.0</p>-->
  <button type="button" class="btn logout-btn" (click)="logout()">Cerrar sesión</button>
</nav>

<!-- MENU SIDEBAR -->
<div *ngIf="getActualPage() != '/login'">
  <app-leftpanel></app-leftpanel>
</div>
<div id="contenedor" class="row contenedor" style="max-width: 100vw !important;">
  <div class="col-md-12">
    <router-outlet></router-outlet>
  </div>
</div>

